import React from "react";

export default function Footer() {
  return (
    <div className="footer">
      <a href="https://github.com/dedyspooky" target="_blank" rel="noreferrer" className="socials">Github.</a>
      <a href="https://linkedin.com/in/aviral-ale" target="_blank" rel="noreferrer" className="socials">Li.</a>
      <a href="https://instagram.com/aviral.who_" target="_blank" rel="noreferrer" className="socials">Insta.</a>
      <a href="mailto:69aviral@gmail.com" target="_blank" rel="noreferrer" className="socials">Mail.</a>
    </div>
  );
}
